import React, { useCallback } from 'react';
import OutsideFormInput from 'components/Input/OutsideFormInput';

interface IToucanPasswordField {
	value: string;
	settingsId: string;
	onChange: (value: string) => void;
}

const ToucanPasswordField: React.FC<IToucanPasswordField> = ({ onChange, value, settingsId }) => {
	const handleChange = useCallback(
		(value: string) => {
			onChange(value.trim());
		},
		[onChange],
	);

	return (
		<OutsideFormInput
			testId="ToucanPasswordField"
			name="password"
			label="passwordLabel"
			errorMessage="enterPassword"
			blockId={settingsId}
			value={value}
			onChange={handleChange}
		/>
	);
};

export default React.memo(ToucanPasswordField);
